import React, { useState, useEffect } from 'react'
import "animate.css";
import YouTubeEmbed from '../../Helpers/Utilities/YouTubeEmbed.js'
import Select from 'react-select'
import { ColorChecker } from '../../Helpers/Functions/ColorChecker.js';
import FilterModal from '../../Helpers/Modal/Filters/FilterModal.js';
import PagesFilter from '../../Helpers/Modal/Filters/PagesFilter.js';

export default function SponsorshipVideoTwo({
    users, visibleFields, team, custom_field_values, user_avatars, logo, page, amounts, page_url, user,
    url, beneficiaryTitles, summaries, active, filter, filters, all_users, title, filterFields, currentOrder,
    filterActive
}) {
    const [selectedUser, setSelectedUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fieldValues, setFieldValues] = useState(custom_field_values)
    const [currentSelection, setCurrentSelection] = useState(null)
    const [buttonTextColor, setButtonTextColor] = useState('white')
    const [buttonColor, setButtonColor] = useState(page.button_color)
    const [alreadyClosed, setAlreadyClosed] = useState(false)
    let logoLink = page.logo_link && page.logo_link.includes('http') ? page.logo_link : `http://${page.logo_link}`

    useEffect(() => {
        if (user) {
          let shownUser = users.filter(u => u.id == user)
          if (shownUser && shownUser.length > 0) {
            setSelectedUser(shownUser[0])
            setIsModalOpen(true)
          }
        }

        let result = ColorChecker(buttonColor)
        if (result == true) setButtonTextColor('black')
    }, [])

    useEffect(() => {
        if (selectedUser) {
            const filterModal = $("#filterModal");
            if (filterModal.is(":visible")) {
                filterModal.hide();
                $(".increase-min-height-f").css({"min-height": ""}); // Reset the height if needed
            }
        }
    }, [selectedUser])

    function canShowPublicField(customFields, field) {
        const foundField = customFields.find(f => f.system_key === field.toString());
        return foundField && foundField.visible;
    }

    const getFieldValues = (user, field) => {
        if (field.system_key == 'bio') return user.bio
        const userRecords = [];

        for (const innerArray of fieldValues) {
            const matchingRecords = innerArray.filter(value => value.record_id == user.id);
            userRecords.push(...matchingRecords);
        }
        if (!userRecords) return null

        let valueObject = userRecords.find(record => record.team_custom_field_id == field.id)
        if (valueObject) return valueObject.value 
        return null
    }


    function getUserAvatar(user) {

        const matchingRecord = user_avatars.find((record) => record.user_id === user.id);
        if (matchingRecord.user_avatar != null) {
            return matchingRecord.user_avatar;
        } else {
            return "https://www.connollymusic.com/hubfs/magic_rosin/user-silhouette.svg"
        }
    }

    const defineAge = (birthday) => {
        if (!birthday) {
            return '';
        }
        const age = Math.floor((new Date() - new Date(birthday)) / (365 * 24 * 60 * 60 * 1000));
        return age.toString();
    }

    const getAmounts = (amount = null) => {
        if (amount) {
            if (page.pass_processing_fee) {
                let raw_amount = parseFloat(amount.amount)
                let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
                let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
                return total;
            }
            return amount.amount
        }
        else {
            if (page.pass_processing_fee) {
                let raw_amount = page.general_sponsorship_amount
                let fee = (((raw_amount + 0.30) / (1 - 0.034)) - raw_amount).toFixed(2)
                let total = (parseFloat(raw_amount) + parseFloat(fee)).toFixed(2)
                return total;
            }

            return page.general_sponsorship_amount
        }
    }

    const unpaidSponsorshipsCount = (id) => {
        let sponsorships = amounts.filter(amount => amount.user_id == id && !amount.paid)
        return sponsorships.length > 0 ? sponsorships.length : 1
      }

      const totalSponsorshipCount = (id) => {
        let sponsorships = amounts.filter(amount => amount.user_id == id)
        return sponsorships.length > 0 ? sponsorships.length : 1
    }

    const userSponsorshipAmount = (user) => {
        let sponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
        return sponsorships.length > 0 ? sponsorships : false
    }

    const handleInputChange = (value) => {
        setCurrentSelection(value)
    }

    const handleStaticChange = (value) => {

    }

    const visitSponsorPage = (user) => {
        let userSponsorships = amounts.filter(amount => amount.user_id == user.id && !amount.paid)
        if (!userSponsorships || (userSponsorships && userSponsorships.length < 1)) {
            window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new`
            return
        } else {
            let sponsorshipsWithId = userSponsorships.filter(amount => currentSelection && amount.id == currentSelection.id)
            if (sponsorshipsWithId && sponsorshipsWithId.length > 0) {
                window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${sponsorshipsWithId[0].id}`
                return
            } else {
                window.location = `/sponsor/${team.id}/${user.id}/${page.id}/signup/new?sponsorship_id=${userSponsorships[0].id}`
                return
            }
        }
    }

    const copyPageLink = (user) => {
        let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
        url = `${url}?preview=1&user=${user.id}`;
      
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            Alert.show('notice', 'Copied to clipboard');
          }).catch((error) => {
            // Clipboard API failed, use a fallback method
            console.error('Clipboard writeText error:', error);
            fallbackCopyTextToClipboard(url);
          });
        } else {
          // Clipboard API not available, use a fallback method
          fallbackCopyTextToClipboard(url);
        }
      }
      
      function fallbackCopyTextToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
      
        try {
          document.execCommand('copy');
          Alert.show('notice', 'Copied to clipboard');
        } catch (err) {
          console.error('Fallback copy failed:', err);
        }
      
        document.body.removeChild(textArea);
      }

      const getDescription = (user) => {
        let description = summaries.find(summary => summary.user_id == user.id)
        return description ? description.summary : page.body
      }

  return (
    <div>
        <div style={{
            backgroundColor: page.primary, 
            position: 'relative', 
            width: '100vw', 
            left: '50%',
            marginLeft: '-50vw', 
            textAlign: 'right', 
            minHeight: '80px',
            color: `${page.text_color} !important`
        }}>     
            {page.filter_type == 'Pop Up' && 
                <div style={{height: '80px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', color: page.text_color, textAlign: 'left'}} className=' pf-button-hover-remove'>
                    {!selectedUser &&
                        <>
                            {active && <span className='mr-2'><b>Filter is currently active</b></span>}
                            <button className='btn btn-primary position-relative' style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor, marginRight: '20px'}} id="ellipsisButton">
                                Show Filters
                            </button>
                        </>
                    }

                    <div id="filterModal" className="position-absolute filter-modal-video-2">
                        <FilterModal 
                            title={title}
                            filter={filter}
                            users={all_users}
                            filters={filters}
                            active={active}
                            custom_fields={visibleFields}
                            pageID={page.id}
                            team={team}
                        />
                    </div>
                </div>
            }

            {(page.filter_type == 'In Page Open' || page.filter_type == 'In Page Close') &&
                <>
                    {!selectedUser &&
                        <div style={{textAlign: 'left'}}>
                            <PagesFilter 
                                team={team}
                                beneficiariesTitles={beneficiaryTitles}
                                page={page}
                                filterFields={filterFields}
                                currentOrder={currentOrder}
                                url={url}
                                filterActive={filterActive}
                                inverted={true}
                                openOnLoad={page.filter_type == 'In Page Open' && !alreadyClosed}
                            />
                        </div>
                    }
                </>
            }
        </div>

        {logo && 
            <div className='logo'>
                {page.logo_link &&
                    <a href={logoLink} target="_blank">
                        <img src={logo} alt={team.name} className='cu-template-logo' />
                        <span class="sr-only">{team.name}</span>
                    </a>
                }
                {!page.logo_link &&
                    <>
                        <img src={logo} alt={team.name} className='cu-template-logo' />
                        <span class="sr-only">{team.name}</span>
                    </>
                }
            </div>
        }

        <div className="main-content" style={{color: page.text_color}}>
            <h2 style={{fontSize: '1.8rem', marginBottom: '1.0rem'}}>
                { page.title }
            </h2>
            <div className="row">
                <div className="col-sm-12">
                    <div dangerouslySetInnerHTML={{ __html: selectedUser ? getDescription(selectedUser) : page.body }} className='message-container template-two-para' style={{marginBottom: '2.0rem'}}>
                </div>
            </div>
        </div>
        <div>
            {!selectedUser &&
                <div className="row row-projects">
                    {users.map(user => {
                        let avatar = getUserAvatar(user);
                        return (
                            <div className="col-sm-6 col-lg-3 mt-3" key={user.id} onClick={() => {
                                setSelectedUser(user)
                                setAlreadyClosed(true)
                            }} style={{cursor: 'pointer'}}>
                                <div>
                                    {avatar &&
                                        <div className="p-2">
                                            <div style={{backgroundImage: `url(${avatar})`}} className="sponsorship-video-images" />
                                        </div>
                                    }
                                    <div className="pt-2 text-center">
                                        <h4 className="mb-1 fw-bold">
                                            {canShowPublicField(visibleFields, 'first_name') &&
                                                `${user.first_name} `
                                            }

                                            {canShowPublicField(visibleFields, 'last_name') &&
                                                `${user.last_name}`
                                            }
                                        </h4>
                                    </div>
                                </div>
                                {page.general_sponsorship_amount && unpaidSponsorshipsCount(user.id) > 1 &&
                                    <p style={{textAlign: 'center'}}>
                                        <b>{`${unpaidSponsorshipsCount(user.id)} of ${totalSponsorshipCount(user.id)} sponsorships available`}</b>
                                    </p>
                                }
                            </div>
                        )
                    })}
                </div>
            }

            {selectedUser &&
                <div>
                    <div className='row sponsorship-video-mobile-user' style={{marginTop: '60px', marginLeft: 'auto', marginRight: 'auto'}}>
                        <div className='col-lg-1'></div>
                        <div className='col-md-6 col-lg-7' style={{textAlign: 'left'}}>
                            <h3 className='no-mobile' style={{textAlign: 'left'}}>
                                <a onClick={() => setSelectedUser(null)} style={{cursor: 'pointer'}}>
                                    <i className="fa fa-chevron-left mr-2"></i> Back
                                </a>
                            </h3>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h4 className='no-mobile' style={{textAlign: 'right'}}>
                                <a onClick={() => copyPageLink(selectedUser)} style={{cursor: 'pointer'}}>
                                    Share <i class="fas fa-share-square"></i>
                                </a>
                            </h4>
                            <h3 className='mobile-only'>
                                <div className='d-flex justify-content-between'>
                                    <a onClick={() => setSelectedUser(null)} style={{cursor: 'pointer'}}>
                                        <i className="fa fa-chevron-left mr-2"></i> Back
                                    </a>
                                    <a onClick={() => copyPageLink(selectedUser)} style={{cursor: 'pointer', textAlign: 'right'}}>
                                        Share <i class="fas fa-share-square"></i>
                                    </a>
                                </div>
                            </h3>
                        </div>
                        <div className='col-lg-1'></div>
                    </div>

                    <div>
                        <div className='col-md-6 col-lg-3' style={{margin: 'auto'}}>
                            <div style={{backgroundImage: `url(${getUserAvatar(selectedUser)})`}} className="sponsorship-video-images" />
                        </div>
                        <div className='col-md-6 col-lg-7' style={{margin: 'auto'}}>
                            <h1 style={{textAlign: 'center'}}>
                                {canShowPublicField(visibleFields, 'first_name') &&
                                    `${selectedUser.first_name} `
                                }

                                {canShowPublicField(visibleFields, 'last_name') &&
                                    `${selectedUser.last_name}`
                                }
                            </h1>
                        </div>
                        <div className='col-md-6 col-lg-3' style={{margin: 'auto'}}>
                            {page.general_sponsorship_amount && userSponsorshipAmount(selectedUser) && userSponsorshipAmount(selectedUser).length > 1 &&
                                <div className='form-group'>
                                    <label htmlFor='select-audience'>Sponsor</label>
                                    <div className="input-group">
                                        <Select
                                            className="w-100 select-audience"
                                            classNamePrefix="select-audience"
                                            value={currentSelection ? currentSelection : userSponsorshipAmount(selectedUser)[0]}
                                            onChange={(value) => handleInputChange(value)}
                                            options={userSponsorshipAmount(selectedUser)}
                                            getOptionLabel={option => `$${getAmounts(option)} / Month`}
                                            getOptionValue={option => option.id }
                                        />
                                    </div>
                                </div>
                            }

                            {/* Only one sponsorship amount available */}
                            {page.general_sponsorship_amount && userSponsorshipAmount(selectedUser) && userSponsorshipAmount(selectedUser).length == 1 &&
                                <div className='mt-3'>
                                    <h4>Sponsor: {`$${getAmounts(userSponsorshipAmount(selectedUser)[0])} / Month`}</h4>
                                </div>
                            }
                            
                            {page.general_sponsorship_amount && !userSponsorshipAmount(selectedUser) &&
                                <div className='mt-3'>
                                    <h4>Sponsor: {`$${getAmounts()} / Month`}</h4>
                                </div>
                            }

                            {page.general_sponsorship_amount && unpaidSponsorshipsCount(selectedUser.id) > 1 &&
                                <h5 style={{textAlign: 'center'}}>
                                    <b>{`${unpaidSponsorshipsCount(selectedUser.id)} of ${totalSponsorshipCount(selectedUser.id)} sponsorships available`}</b>
                                </h5>
                            }

                            <div className="mt-3">
                                <button className="w-100 btn btn-primary" onClick={() => visitSponsorPage(selectedUser)} style = {{backgroundColor: page.button_color, borderColor: page.button_color, color: buttonTextColor}}>
                                    {page.button_text && <>{page.button_text}</>}
                                    {!page.button_text && <>Sponsor</>}
                                </button>
                            </div>
                        </div>
                        <div className='col-md-6 col-lg-7' style={{margin: 'auto', marginTop: '30px'}}>
                            {selectedUser.add_youtube_video && selectedUser.video_url &&
                                <div style={{marginBottom: '30px'}}>
                                    <YouTubeEmbed youtubeLink={selectedUser.video_url} height="250" width="100%"/>
                                </div>
                            }

                            <div className="sponsorship-template-age">
                                {canShowPublicField(visibleFields, 'birthday') && selectedUser.birthday != null &&
                                    <h4>{"Age: " + selectedUser.birthday + " (" + defineAge(selectedUser.birthday) + " years old)"}</h4>
                                }
                            </div>

                            {selectedUser.bio &&
                                <div>
                                    <h4>Bio</h4>
                                    <p>{ selectedUser.bio }</p>
                                </div>
                            }


                            <div>
                                {visibleFields.map(field => {
                                    if (field.system_key === "first_name" || field.system_key === "last_name" || field.system_key === "birthday" ||
                                        field.system_key == 'bio'
                                        ) {
                                        return null;
                                    }

                                    const value = getFieldValues(selectedUser, field);
                                    return (
                                        <div>
                                            {value && value != "" &&
                                                <div key={field.id} className="mb-2 sponsorship-template-fields">
                                                    <h4 className="text-bold sponsorship-template-field-name">{field.name}</h4>
                                                    {value ? (
                                                            <p>
                                                                {field.value_type == 'link' &&
                                                                    <a href={value} target="_blank">{ field.anchor_text ? field.anchor_text : field.name }</a> 
                                                                }
                                                                {field.value_type !== 'link' &&
                                                                    <span>{value}</span>
                                                                }
                                                            </p>
                                                    ) : (
                                                        <p>No data available.</p>
                                                    )}
                                                </div>
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
    </div>
  )
}
